import { CAMPAIGNS_WITHOUT_PER_PERSON_PRICE } from '@/constants';

const isCampaignHidePerPersonPrice = (campaign) =>
  CAMPAIGNS_WITHOUT_PER_PERSON_PRICE.some((slug) =>
    campaign?.slug?.includes(slug),
  );

export default isCampaignHidePerPersonPrice;
